import { CategoryNameEnum } from '@kortxio/hub-api';

// Notification privileges, mirroring the hub-api notification-category policy.
const NOTIFICATIONS_READ_PRIVILEGE = 'NOTIFICATIONS_READ';
const NOTIFICATIONS_READ_FRANCHISEE_PRIVILEGE = 'NOTIFICATIONS_READ_FRANCHISEE';

export const userVisibleMagicBellCategories: readonly string[] = [
  CategoryNameEnum.Billing,
  CategoryNameEnum.Campaign,
  CategoryNameEnum.Dashboard,
  CategoryNameEnum.Document,
  CategoryNameEnum.General,
  CategoryNameEnum.Support,
] as const;

// The franchisee subset only manages categories that apply to it.
// Campaign covers status + update (sub-category); Document covers new documents.
export const franchiseeVisibleMagicBellCategories: readonly string[] = [
  CategoryNameEnum.Campaign,
  CategoryNameEnum.Document,
] as const;

export const permittedMagicBellCategories = (
  privileges: Iterable<string> | undefined
): readonly string[] => {
  const privilegeSet = new Set(privileges ?? []);

  if (privilegeSet.has(NOTIFICATIONS_READ_PRIVILEGE)) {
    return userVisibleMagicBellCategories;
  }

  if (privilegeSet.has(NOTIFICATIONS_READ_FRANCHISEE_PRIVILEGE)) {
    return franchiseeVisibleMagicBellCategories;
  }

  return [];
};
